import { render, staticRenderFns } from "./storeMonthNumStatistic.vue?vue&type=template&id=a2bd4db2&scoped=true"
import script from "./storeMonthNumStatistic.vue?vue&type=script&lang=js"
export * from "./storeMonthNumStatistic.vue?vue&type=script&lang=js"
import style0 from "./storeMonthNumStatistic.vue?vue&type=style&index=0&id=a2bd4db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd4db2",
  null
  
)

export default component.exports